"use client";

import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";

import { applyStoredThemePreferences } from "@/lib/theme/apply-preferences";
import { getMyProfile } from "@/lib/api/endpoints/users";
import { useAuthStore } from "@/modules/auth/store";

/** Loads saved theme preferences from the user profile after sign-in. */
export function ThemePreferencesSync() {
  const userId = useAuthStore((s) => s.user?.id);

  const profileQuery = useQuery({
    queryKey: ["my-profile", "theme-preferences", userId],
    queryFn: getMyProfile,
    enabled: Boolean(userId),
    staleTime: 5 * 60_000,
    refetchOnWindowFocus: false,
  });

  useEffect(() => {
    if (profileQuery.data?.preferences) {
      applyStoredThemePreferences(profileQuery.data.preferences);
    }
  }, [profileQuery.data?.preferences]);

  return null;
}
